import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { TokenService } from '@services/auth/token.service';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  public header: string;

  constructor(
    public http: HttpClient,
    public authService: AuthService,
    private _token: TokenService
  ) {}

  // System-setting api implementation start

  setTimeZone(time_data: Object) {
    const URL = `${environment.api}settings/time-zone`;

    return this.http
      .post(URL, time_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setBiddingPointRatio(bid_ratio: Object) {
    const URL = `${environment.api}settings/bidding-point-ratio`;

    return this.http
      .post(URL, bid_ratio, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setSocialMediaUrl(social_media_urls: Object) {
    const URL = `${environment.api}settings/social-media`;

    return this.http
      .post(URL, social_media_urls, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setDateTimeFormat(date_time_format: Object) {
    const URL = `${environment.api}settings/date-time-format`;

    return this.http
      .post(URL, date_time_format, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setCurrency(currency: Object) {
    const URL = `${environment.api}settings/currency`;

    return this.http
      .post(URL, currency, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setAnalyticstags(analytics_tags: Object) {
    const URL = `${environment.api}settings/analytics-tags`;

    return this.http
      .post(URL, analytics_tags, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setProductStage(product_stages: any) {
    const URL = `${environment.api}settings/product-stage`;

    return this.http
      .post(URL, product_stages, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  deleteProductStage(stage_id: any) {
    const URL = `${environment.api}settings/product-stage/${stage_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setProductAttribute(product_attribute: Object) {
    const URL = `${environment.api}settings/product-attribute/add`;

    return this.http
      .post(URL, product_attribute, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getSystemSettingView() {
    const URL = `${environment.api}settings/system-settings-view`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getProductStageList() {
    const URL = `${environment.api}settings/product-stage/list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  editProductStageList(edit_data: any) {
    const URL = `${environment.api}settings/product-stage/edit`;

    return this.http
      .put(URL, edit_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getProductAttributeList() {
    const URLProd = `${environment.api}settings/product-attribute/list`;
    // const URLStage = `${environment.v4}settings/product-attribute/list`;

    return this.http
      .get(URLProd, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  deleteAttribute(attribute_id: any) {
    const URL = `${environment.api}settings/product-attribute/delete/${attribute_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  editAttribute(attribute_id: any, data: any) {
    const URL = `${environment.api}settings/product-attribute/edit/${attribute_id}`;
    let accessToken = this.authService.userData.data.tokens.access_token;
    return this.http
      .put(URL, data, {
        headers: {
          Authorization: accessToken,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setUserRoles(user_role: Object) {
    const URL = `${environment.api}settings/user-role-add`;

    return this.http
      .post(URL, user_role, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  deleteUserRole(role_id: any) {
    const URL = `${environment.api}settings/user-role-delete/${role_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  searchOption(data: Object) {
    const URL = `${environment.api}settings/product-attribute/search-options`;
    let accessToken = this.authService.userData.data.tokens.access_token;

    return this.http
      .put(URL, data, {
        headers: {
          Authorization: accessToken,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getPermissionList() {
    const URL = `${environment.api}permission-list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getUserRolePermissionList(user_id: any) {
    const URL = `${environment.api}user-role/permission-list/${user_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getBiddingPointRatio() {
    const URL = `${environment.api}settings/system-bidding-ratio`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  // END

  // api-key-management api implementation start

  setPaymentGateway(payment_data: Object) {
    const URL = `${environment.api}settings/payment-gateway-api`;

    return this.http
      .post(URL, payment_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setGoogleMapKey(map_key_data: Object) {
    const URL = `${environment.api}settings/google-map-api`;

    return this.http
      .post(URL, map_key_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setSmsGateway(sms_data: Object) {
    const URL = `${environment.api}settings/sms-gateway-api`;

    return this.http
      .post(URL, sms_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  setEmailKeys(email_keys_data: Object) {
    const URL = `${environment.api}settings/email-api`;

    return this.http
      .post(URL, email_keys_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  settingsInfo() {
    const URL = `${environment.api}settings/api-management-view`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  //END

  //Sms-Template api implementation start

  setSmsTemplate(sms_template_data: Object) {
    const URL = `${environment.api}settings/sms-template-add`;

    return this.http
      .post(URL, sms_template_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getSmsTemplateList() {
    const URL = `${environment.api}settings/sms-template-list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getEditSmsTemplate(attribute_id: any) {
    const URL = `${environment.api}settings/sms-template-view/${attribute_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  deleteSmsTemplate(attribute_id: any) {
    const URL = `${environment.api}settings/sms-template-delete/${attribute_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  // END

  //Email-Template api implementation start

  setEmailTemplate(email_template_data: Object) {
    const URL = `${environment.api}settings/email-template-add`;

    return this.http
      .post(URL, email_template_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getEmailTemplateList() {
    const URL = `${environment.api}settings/email-template-list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getEditEmailTemplate(attribute_id: any) {
    const URL = `${environment.api}settings/email-template-view/${attribute_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  deleteEmailTemplate(attribute_id: any) {
    const URL = `${environment.api}settings/email-template-delete/${attribute_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  //END

  // User role permission Api Implementation Start

  userRolePermissionList(user_id: any) {
    const URL = `${environment.api}user-role/permission-list/${user_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  //END

  // Transportation Cost Api Implementation Start

  setTransportationCost(transportation_cost_data: Object) {
    const URL = `${environment.api}transport/cost`;

    return this.http
      .post(URL, transportation_cost_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getTransportationCost() {
    const URL = `${environment.api}transport/cost/list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  deleteransportationCost(transport_uuid: any) {
    const URL = `${environment.api}transport/cost/remove/${transport_uuid}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  //END
}
